function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M299.839,284.585c-17.696,5.991-36.172,9.023-55.055,9.023c-28.93,0-56.9-7.112-81.676-20.679 c-19.631,17.168-44.902,26.808-71.149,26.808c-9.047,0-17.793-1.236-26.198-3.341l26.02,140.511h264.528l24.182-130.561 c-5.454,0.927-11.022,1.52-16.737,1.52C340.059,307.866,317.73,299.672,299.839,284.585z M171.871,411.058 c-0.39,0.057-0.788,0.081-1.179,0.081c-3.975,0-7.446-2.918-8.031-6.966l-10.177-70.393c-0.642-4.438,2.439-8.568,6.885-9.21 c4.406-0.585,8.568,2.439,9.21,6.885l10.177,70.393C179.398,406.286,176.309,410.416,171.871,411.058z M238.777,403.376 c0,4.487-3.642,8.129-8.129,8.129c-4.487,0-8.129-3.642-8.129-8.129v-71.125c0-4.487,3.642-8.129,8.129-8.129 c4.487,0,8.129,3.642,8.129,8.129V403.376z M298.636,404.173c-0.585,4.048-4.064,6.966-8.031,6.966 c-0.39,0-0.78-0.024-1.179-0.081c-4.438-0.642-7.527-4.763-6.885-9.21l10.177-70.393c0.65-4.446,4.796-7.478,9.21-6.885 c4.438,0.642,7.527,4.763,6.885,9.21L298.636,404.173z"
}), React.createElement("path", {
  d: "M53.527,274.986c1.479,0.683,2.975,1.341,4.495,1.951c1.463,0.577,2.943,1.114,4.43,1.626 c9.267,3.146,19.167,4.926,29.499,4.926c27.353,0,51.852-12.014,68.695-30.97c23.752,15.582,52.738,24.841,84.131,24.841 c20.955,0,40.822-4.162,58.81-11.518c15.168,15.851,36.489,25.776,60.16,25.776c6.877,0,13.526-0.927,19.923-2.495 c1.455-0.358,2.918-0.683,4.341-1.114c1.504-0.455,2.959-1.024,4.422-1.561c31.856-11.705,54.632-42.22,54.632-78.14 c0-37.196-24.386-68.67-58.03-79.384c-8.023-66.809-69.516-118.767-144.25-118.767c-63.907,0-118.051,38.034-137.462,90.796 c-5.007-0.845-10.12-1.382-15.371-1.382C41.163,99.571,0,140.742,0,191.521C0,228.571,21.955,260.419,53.527,274.986z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgSobremesa = function SvgSobremesa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 447.064 447.064",
    style: {
      enableBackground: "new 0 0 447.064 447.064"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSobremesa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sobremesa.7f2b7ba2.svg";
export { ForwardRef as ReactComponent };